import "./loader.css";
export default function Loader(){
    return (
        <div className="w-100 loader-container text-center">
            <div className="lds-dual-ring"></div>
        </div>
    );
}